import Vue from 'vue'

Vue.component('v-button', (resolve) => {
  require(['@/components/form/button.vue'], resolve)
})
Vue.component('v-input-text', (resolve) => {
  require(['@/components/form/text.vue'], resolve)
})
Vue.component('v-input-select', (resolve) => {
  require(['@/components/form/select.vue'], resolve)
})
Vue.component('v-input-checkbox', (resolve) => {
  require(['@/components/form/checkbox.vue'], resolve)
})
Vue.component('v-input-money', (resolve) => {
  require(['@/components/form/money.vue'], resolve)
})
Vue.component('v-input-datepicker', (resolve) => {
  require(['@/components/form/datepicker.vue'], resolve)
})
Vue.component('v-loading', (resolve) => {
  require(['@/components/includes/Loading.vue'], resolve)
})
Vue.component('v-modal', (resolve) => {
  require(['@/components/includes/Modal.vue'], resolve)
})
Vue.component('v-alert', (resolve) => {
  require(['@/components/includes/Alert.vue'], resolve)
})
Vue.component('v-title', (resolve) => {
  require(['@/components/includes/TitlePage.vue'], resolve)
})


// WEBPACK FOOTER //
// ./src/components.js